import { render, staticRenderFns } from "./YFooter.vue?vue&type=template&id=7e233648&scoped=true&"
import script from "./YFooter.vue?vue&type=script&lang=js&"
export * from "./YFooter.vue?vue&type=script&lang=js&"
import style0 from "./YFooter.vue?vue&type=style&index=0&id=7e233648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e233648",
  null
  
)

export default component.exports